import { useLayoutEffect, useState } from 'react'

const DEFAULT_SCHEDULE_HEIGHT = 'calc(100vh - 120px)'
const SCHEDULE_CALENDAR_PADDING = 40

const getScheduleHeight = (): string => {
  const appHeader = document.getElementById('app-header')
  const scheduleHeader = document.getElementById('schedule-header-calendar')

  if (!appHeader || !scheduleHeader) {
    return DEFAULT_SCHEDULE_HEIGHT
  }

  const headerHeight = getComputedStyle(appHeader).height
  const scheduleHeaderHeight = getComputedStyle(scheduleHeader).height

  return `calc(100vh - ${headerHeight} - ${scheduleHeaderHeight} - ${SCHEDULE_CALENDAR_PADDING}px)`
}

export const useScheduleHeight = () => {
  const [scheduleHeight, setScheduleHeight] = useState(DEFAULT_SCHEDULE_HEIGHT)

  useLayoutEffect(() => {
    setScheduleHeight(getScheduleHeight())

    const handleResize = () => setScheduleHeight(getScheduleHeight())
    window.addEventListener('resize', handleResize)

    return () => window.removeEventListener('resize', handleResize)
  }, [])

  return scheduleHeight
}
